/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { OccupancySpots } from './Components/OccupancySpots';

/**
 * StudioOccupancy Component
 * @returns {Element}
 * @constructor
 * @param props
 */
export function StudioOccupancy(props) {
  const { studioId, isNeosBackend } = props;

  return (
    (!studioId && !isNeosBackend)
      ? null
      : (
        <Box className="studio-occupancy">
          <Box className="studio-occupancy__body">
            <Typography className="studio-occupancy__header" component="p">
              Aktuelle
              Studioauslastung
            </Typography>
            <OccupancySpots studioId={studioId} isNeosBackend={isNeosBackend} />
          </Box>
        </Box>
      )
  );
}

StudioOccupancy.propTypes = {
  studioId: PropTypes.string,
  isNeosBackend: PropTypes.string,
};

StudioOccupancy.defaultProps = {
  studioId: null,
  isNeosBackend: null,
};
